import { useCallback, useMemo, useReducer } from 'react';

export const INITIAL = {
  step: 1,
  type: 'Joyeuse',
  category: '',
  title: '',
  description: '',
  image: '',
  goal: 200000,
  duration: 30,
  country: "C\u00f4te d'Ivoire",
  provider: 'wave',
  beneficiaryPhone: '',
  beneficiaryHolder: '',
  contacts: [],
  channels: ['whatsapp'],
};

function reducer(state, action) {
  switch (action.type) {
    case 'reset':
      return { ...INITIAL, type: action.payload || 'Joyeuse' };
    case 'set':
      return { ...state, [action.key]: action.value };
    case 'next':
      return { ...state, step: Math.min(6, state.step + 1) };
    case 'prev':
      return { ...state, step: Math.max(1, state.step - 1) };
    default:
      return state;
  }
}

const MIN_TITLE = 3;
const MIN_DESCRIPTION = 10;
const MIN_GOAL = 1000;
const MIN_PHONE_LENGTH = 8;

function isStepValid(state) {
  const { step, category, title, description, goal, duration, provider, beneficiaryPhone } = state;
  if (step === 1) return Boolean(category);
  if (step === 2) return title.trim().length >= MIN_TITLE && description.trim().length >= MIN_DESCRIPTION;
  if (step === 3) return Number(goal) >= MIN_GOAL && Number(duration) >= 1;
  if (step === 4) return Boolean(provider) && beneficiaryPhone.trim().length >= MIN_PHONE_LENGTH;
  return true;
}

export function useWizardState(initialType = 'Joyeuse') {
  const [state, dispatch] = useReducer(reducer, { ...INITIAL, type: initialType });

  const set = useCallback((key) => (value) => dispatch({ type: 'set', key, value }), []);
  const setValue = useCallback((key, value) => dispatch({ type: 'set', key, value }), []);
  const next = useCallback(() => dispatch({ type: 'next' }), []);
  const prev = useCallback(() => dispatch({ type: 'prev' }), []);
  const reset = useCallback((type) => dispatch({ type: 'reset', payload: type }), []);

  const canNext = useMemo(() => isStepValid(state), [state]);

  return { state, set, setValue, next, prev, reset, canNext };
}
